module.exports = __webpack_public_path__ + "static/media/zeya_drawing_01.617659a0.png";